/** @format */
import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, ViewEncapsulation } from '@angular/core';
import { StudyTermData } from '../../timing.types';

export type TimelineStudyTermHeadingLevel = 1 | 2 | 3 | 4;
export type TimelineStudyTermChildHeadingLevel = 2 | 3 | 4 | 5;

@Component({
    selector: 'app-timeline-study-term',
    standalone: false,
    templateUrl: './timeline-study-term.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineStudyTermComponent {
    readonly term: InputSignal<StudyTermData> = input.required<StudyTermData>();
    readonly headingLevel: InputSignal<TimelineStudyTermHeadingLevel> = input.required<TimelineStudyTermHeadingLevel>();

    protected readonly childHeadingLevel: Signal<TimelineStudyTermChildHeadingLevel> = computed(
        () => <TimelineStudyTermChildHeadingLevel>(this.headingLevel() + 1),
    );
}
